import {cva} from 'class-variance-authority'

// v3 "filled" field: bottom-border only, top corners rounded, mint fill.
export const inputTextAreaFieldVariants = cva(
  'flex w-full min-h-20 items-start rounded-t-[4px] border-b border-solid px-3 py-2 transition-colors',
  {
    variants: {
      isError: {
        true: 'border-error bg-[rgba(255,128,140,0.16)]',
        false: 'bg-[#f6f9f8] border-divider focus-within:border-primary',
      },
      disabled: {
        true: 'bg-action-disabled-background border-divider',
      },
    },
    defaultVariants: {
      isError: false,
    },
  },
)

export const textareaBaseClass =
  'ds-scroll-area w-full flex-1 resize-none bg-transparent outline-none text-base font-semibold text-text-secondary placeholder:text-text-disabled disabled:text-text-disabled focus:text-text-primary'
